import React from "react";
import { BrowserRouter } from "react-router-dom";
import DynamicRoutes from "./components/Route/DynamicRoutes";
import AuthHandler from "./utils/AuthHandler";
import InterceptorSetup from "./utils/InterceptorSetup";

const App = () => {
  return (
    <BrowserRouter>
      <InterceptorSetup/>
        <AuthHandler />
        <DynamicRoutes />
    </BrowserRouter>
  );
};

export default App;
